import React from "react";
import I18n from "i18n.js.erb";

const formatPrice = (value) => {
  const fixed = value.toFixed(2);
  const [integer, decimals] = fixed.split('.');
  return { integer, decimals };
};

const splitTextToLines = (text, maxLines) => {
  if (!text) return Array(maxLines).fill('');
  const words = text.split(' ');
  const mid = Math.ceil(words.length / 2);
  const lines = [
    words.slice(0, mid).join(' '),
    words.slice(mid).join(' '),
  ];
  while (lines.length < maxLines) lines.push('');
  return lines.slice(0, maxLines);
};

// Con onLineChange l'etichetta diventa il gemello modificabile usato nel modulo di modifica: le righe
// si scrivono dentro l'etichetta stessa, con gli stessi caratteri e gli stessi ingombri di quella vera
const EInkSmartLabel = ({ cell, onLabelClick, onHoverMouceIcon, onLineChange }) => {

  const label = cell?.label || {};
  const qrCodeUrl = cell?.grading_certificate_url
  const hasPrice = label.price != null && label.price > 0;
  const priceParts = hasPrice ? formatPrice(label.price) : null;
  const isError = cell?.state === 'error' && !onLineChange;
  const diagnostics = cell?.diagnostics || {};
  // Cella libera e senza errori: l'etichetta non resta bianca e muta, mostra il marchio come fa
  // l'e-ink del totem quando il posto e' vuoto
  const isEmptyTemplate = !cell?.product_id && !isError;

  return (
    <div
      id={`cell_${cell.id}`}
      className={`e-ink-smart-label${onLabelClick ? ' e-ink-smart-label--clickable' : ''}${onHoverMouceIcon === 'rotate' ? ' e-ink-smart-label--cursor-rotate' : ''}`}
      onClick={onLabelClick || undefined}
    >
      <div className={`e-ink-smart-label__inner${isError ? ' e-ink-smart-label__inner--error' : ''}${isEmptyTemplate ? ' e-ink-smart-label__inner--empty' : ''}`}>
        {/* Il marchio sta sopra la struttura di sempre, che resta al suo posto solo nascosta: cosi'
            l'etichetta vuota ingombra esattamente quanto una piena e la griglia non balla */}
        {isEmptyTemplate && (
          <img src="/images/logo.svg" alt="" className="e-ink-smart-label__empty-logo" />
        )}
        <div className="e-ink-smart-label__price-section">
          {!isError && hasPrice ? (
            <div className="e-ink-smart-label__price">
              <span className="e-ink-smart-label__price-integer">{priceParts.integer},</span>
              <span className="e-ink-smart-label__price-decimals">{priceParts.decimals}</span>
              <span className="e-ink-smart-label__price-currency">€</span>
            </div>
          ) : (
            <div className="e-ink-smart-label__price e-ink-smart-label__price--empty">&nbsp;</div>
          )}
        </div>

        <div className="e-ink-smart-label__info-lines">
          {isError ? (
            <>
              {splitTextToLines(diagnostics.extra_status_message, 2).map((line, i) => (
                <p key={`e${i}`} className="e-ink-smart-label__line e-ink-smart-label__line--error-extra">
                  {line || <span>&nbsp;</span>}
                </p>
              ))}
              {splitTextToLines(diagnostics.status_message, 2).map((line, i) => (
                <p key={`s${i}`} className="e-ink-smart-label__line e-ink-smart-label__line--error-status">
                  {line || <span>&nbsp;</span>}
                </p>
              ))}
            </>
          ) : (
            <>
              {['line_1', 'line_2', 'line_3', 'line_4'].map((line) => (
                onLineChange ? (
                  <input
                    key={line}
                    type="text"
                    className="e-ink-smart-label__line e-ink-smart-label__line--editable"
                    value={label[line] || ''}
                    onChange={(event) => onLineChange(line, event.target.value)}
                  />
                ) : (
                  <p key={line} className="e-ink-smart-label__line">{label[line] ? label[line] : <span>&nbsp;</span>}</p>
                )
              ))}
            </>
          )}
        </div>

        <div className={`e-ink-smart-label__name-section${isError ? ' e-ink-smart-label__name-section--error' : ''}`}>
          {onLineChange ? (
            <input
              type="text"
              className="e-ink-smart-label__name e-ink-smart-label__name--editable"
              value={label.line_5 || ''}
              onChange={(event) => onLineChange('line_5', event.target.value)}
            />
          ) : (
            <p className="e-ink-smart-label__name">
              {isError ? I18n.t('js.loopDashboard.cellErrorTitle') : (label.line_5 ? label.line_5 : <span>&nbsp;</span>)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EInkSmartLabel;
